import React from "react";

const MasterCardLargeIcon = () => {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Mastercard"
    >
      <rect width="36" height="24" rx="1.5" fill="#F6F6F9" />
      <path
        d="M21.7104 5.06982H14.2698V18.4409H21.7104V5.06982Z"
        fill="#FF5F00"
      />
      <path
        d="M14.7422 11.7553C14.7410 10.4676 14.9329 9.19649 15.5955 8.03822C16.2583 6.87993 17.1270 5.86487 18.0001 5.06984C16.7357 4.08381 15.2291 3.47061 13.6426 3.30033C12.0561 3.13007 10.4538 3.40956 9.01863 4.10691C7.58351 4.80426 6.37353 5.89133 5.52701 7.24383C4.6805 8.59635 4.23156 10.1597 4.23156 11.7553C4.23156 13.3509 4.6805 14.9143 5.52701 16.2668C6.37353 17.6193 7.58351 18.7064 9.01863 19.4037C10.4538 20.1011 12.0561 20.3806 13.6426 20.2103C15.2291 20.0400 16.7357 19.4268 18.0001 18.4408C17.1272 17.6457 16.2583 16.6307 15.5955 15.4724C14.9329 14.3141 14.7410 13.043 14.7422 11.7553Z"
        fill="#EB001B"
      />
      <path
        d="M31.7483 11.7553C31.7483 13.3509 31.2994 14.9143 30.4529 16.2668C29.6064 17.6193 28.3965 18.7064 26.9614 19.4037C25.5263 20.1011 23.924 20.3805 22.3376 20.2103C20.751 20.04 19.2446 19.4268 17.9801 18.4408C18.8522 17.6450 19.5204 16.6298 19.9831 15.4716C20.4456 14.3136 20.7379 13.0428 20.7379 11.7553C20.7379 10.4678 20.4456 9.19709 19.9831 8.03899C19.5204 6.88091 18.8522 5.86566 17.9801 5.06984C19.2446 4.08381 20.751 3.47061 22.3376 3.30033C23.924 3.13006 25.5263 3.40958 26.9614 4.10694C28.3965 4.80429 29.6064 5.89136 30.4529 7.24386C31.2994 8.59638 31.7483 10.1598 31.7483 11.7553Z"
        fill="#F79E1B"
      />
      <path
        d="M30.9371 17.0246V16.7508H31.0475V16.6952H30.7664V16.7508H30.8768V17.0246H30.9371ZM31.4828 17.0246V16.6946H31.3967L31.2977 16.9215L31.1984 16.6946H31.1121V17.0246H31.173V16.7757L31.266 16.9904H31.329L31.422 16.7751V17.0246H31.4828Z"
        fill="#F79E1B"
      />
    </svg>
  );
};

export default MasterCardLargeIcon;
